<template>
  <div>
    <vx-card no-shadow>
      <vs-breadcrumb class="mt-2">
        <li><router-link to="/content">Content</router-link><span class="vs-breadcrum--separator">/</span></li>
        <li>
          <router-link :to="articleCategoryLink">{{ articleCategoryLinkTitle }}</router-link
          ><span class="vs-breadcrum--separator">/</span>
        </li>
        <li aria-current="page" class="active">Edit Article</li>
      </vs-breadcrumb>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-2/5 w-full">
          <h2>Article</h2>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Title</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <i8n-input v-if="article" label="" :content.sync="article.title" class="w-full" />
        </div>
      </div>

      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Content</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <i8n-quill-editor v-if="article" label="" :content.sync="article.content" />
        </div>
      </div>

      <vs-divider />

      <div class="vx-row">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Availability</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full" style="display: flex">
          <div class="my-4">
            <small class="date-label">Available from</small>
            <flat-pickr
              v-if="article"
              :config="configdateStartTimePicker"
              v-model="startDate"
              placeholder="Start..."
              style="display: flex"
            />
          </div>

          <div class="my-4" style="margin-left: 8px">
            <small class="date-label">Available until</small>
            <flat-pickr
              v-if="article"
              :disabled="!article.hasEndAvailability"
              :config="configdateEndTimePicker"
              v-model="endDate"
              placeholder="End..."
              style="display: flex"
            />
            <vs-checkbox v-if="article" v-model="article.hasEndAvailability" class="mt-2">End availability?</vs-checkbox>
          </div>
        </div>
      </div>

      <vs-divider />

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Tags (optional)</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-chips v-if="article" placeholder="New Tag" v-model="article.tags" style="width: 100%">
            <vs-chip color="#24c1a0" :key="tag" @click="removeTag(tag)" v-for="tag in article.tags" closable>
              {{ tag }}
            </vs-chip>
          </vs-chips>
          <!-- <p style="font-weight: 600; font-size: 85%; margin-top: 8px">
            User will see the Article when the country tag and at least one other tag matches the user tags.
          </p> -->
        </div>
      </div>

      <vs-divider />

      <!-- IdamSegmentator section - Audience segmentation -->
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Segmentation (who can see)</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <IdamSegmentator v-model="article.userQuery" />
        </div>
      </div>

      <vs-divider />

      <div class="vx-row mb-6">
        <div class="vx-col lg:w-1/1 w-full">
          <h5>Photos &amp; Videos</h5>
          <ArticleImages v-if="article" :article="article" style="width: 100%" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col lg:w-1/1 w-full">
          <h5>Other Files</h5>
          <ArticleFiles v-if="article" :article="article" style="width: 100%" />
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="flex flex-wrap items-center justify-end">
        <vs-button @click="notify" id="notify-button" color="success" class="ml-auto mt-2">Notify</vs-button>
        <vs-button @click="saveInfo" id="save-button" class="ml-auto mt-2">Save Changes</vs-button>
      </div>
    </vx-card>

    <vs-divider />

    <vx-card no-shadow>
      <ChangeLog v-if="article" :source="article.changeLog" />
    </vx-card>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import TypeAhead from "vue2-typeahead";

import IdamSegmentator from "@/components/Custom/IdamSegmentator/IdamSegmentator";

const ArticleImages = () => import("./components/ArticleImages.vue");
const ArticleFiles = () => import("./components/ArticleFiles.vue");
const ChangeLog = () => import("./../../../components/change-log/ChangeLog.vue");

export default {
  components: {
    flatPickr,
    TypeAhead,
    ArticleImages,
    ArticleFiles,
    ChangeLog,
    IdamSegmentator
  },
  props: {},
  data() {
    let ctx = this;

    return {
      article: null,

      configdateStartTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "d-m-Y H:i",
        defaultHour: 18,
        defaultMinute: 0,
        defaultSecond: 0,
        onChange: function (selectedDates) {
          if (selectedDates.length === 0) {
            return;
          }

          ctx.updateStartDate(selectedDates[0]);
        }
      },
      configdateEndTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "d-m-Y H:i",
        defaultHour: 20,
        defaultMinute: 0,
        defaultSecond: 0,
        onChange: function (selectedDates) {
          if (selectedDates.length === 0) {
            return;
          }

          ctx.updateEndDate(selectedDates[0]);
        }
      },

      startDate: null,
      localStartDate: null,
      endDate: null,
      localEndDate: null
    };
  },
  methods: {
    removeTag(item) {
      this.article.tags.splice(this.article.tags.indexOf(item), 1);
    },
    updateStartDate: function (date) {
      console.log("updateStartDate");

      this.localStartDate = new Date(date);
    },
    updateEndDate: function (date) {
      console.log("updateEndDate");

      this.localEndDate = new Date(date);
    },

    getArticle: function () {
      this.$vs.loading();

      const url = process.env.VUE_APP_API + "/Articles/" + this.articleId;

      this.$http
        .get(url)
        .then(resp => {
          console.log("Article:", resp.data);
          this.article = resp.data;

          this.startDate = this.article.startDate;
          this.endDate = this.article.endDate;

          this.updateStartDate(this.article.startDate);
          this.updateEndDate(this.article.endDate);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    notify: function () {
      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#notify-button",
        scale: 0.45
      });

      this.$http
        .put(process.env.VUE_APP_API + "/Articles/" + this.article.articleId + "/notify")
        .then((/*resp*/) => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Notifications sent"
          });
        })
        .catch(err => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not send notifications: " + err
          });
        })
        .finally(() => {
          this.$vs.loading.close("#notify-button > .con-vs-loading");
        });
    },

    saveInfo: function () {
      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#save-button",
        scale: 0.45
      });

      const payload = {
        title: this.article.title,
        content: this.article.content,
        tags: this.article.tags,
        startDate: this.localStartDate,
        endDate: this.localEndDate,
        hasEndAvailability: this.article.hasEndAvailability,
        userQuery: this.article.userQuery
      };

      this.$http
        .put(process.env.VUE_APP_API + "/Articles/" + this.article.articleId, payload)
        .then((/*resp*/) => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Article saved"
          });
        })
        .catch(err => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not save article: " + err
          });
        })
        .finally(() => {
          this.$vs.loading.close("#save-button > .con-vs-loading");
        });
    }
  },
  computed: {
    articleCategoryLink() {
      return "/content/" + this.articleCategoryId;
    },

    articleCategoryLinkTitle() {
      if (this.article === null) {
        return "";
      }

      return this.$translate(this.article.articleCategoryTitle);
    }
  },
  created() {
    this.articleCategoryId = this.$route.params.articleCategoryId;
    this.articleId = this.$route.params.articleId;

    this.getArticle();
  }
};
</script>

<style lang="scss">
.con-chips--remove-all {
  display: none;
}

.horizontal-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.typeahead-container input {
  padding: 0.7rem !important;
  font-size: 1rem !important;
  color: inherit;
  position: relative;
  padding: 0.4rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 100%;
}

.instructor-chip {
  font-size: 14px;
}
</style>